import React from 'react';

// material ui
import { Grid } from '@material-ui/core';

// components
import ClassroomLinkItem, { ClassroomLinkItemProps } from './ClassroomLinkItem';
import ClassroomLinkSkeleton from './ClassroomLinkSkeleton';

// api
import { useClassroomLinksQuery } from 'api/classroomLinks';

export default function ClassroomLinkList() {
  const { data: classroomLinks = [], isFetching } = useClassroomLinksQuery();

  return (
    <Grid container justifyContent='center' spacing={2}>
      {isFetching ? (
        <ClassroomLinkSkeleton />
      ) : (
        classroomLinks.map((item: ClassroomLinkItemProps) => (
          <Grid item xs={6} key={item.key}>
            <ClassroomLinkItem {...item} />
          </Grid>
        ))
      )}
    </Grid>
  );
}
